import type { ReactNode } from 'react';
import { JournalEntriesTable } from './JournalEntriesTable';
import { useJournalEntriesQuery } from './useJournalEntriesQuery';
import type { JournalEntriesLinkActions } from './useJournalEntriesTableColumns';

type Props = JournalEntriesLinkActions & {
  renderExcludedStatus?: (content: ReactNode) => ReactNode;
};

export const JournalEntriesView = ({
  renderExcludedStatus,
  ...actions
}: Props = {}) => {
  'use memo';

  const queryData = useJournalEntriesQuery({
    skip: false,
    modalFilter: undefined,
    modalWhere: undefined,
  });

  return (
    <JournalEntriesTable
      actions={actions}
      filterProps={{ renderExcludedStatus, view: 'all' }}
      queryData={queryData}
    />
  );
};
